// ── Search → Show Detail shared-poster transition ───────────────────────────
// Rebuilt from the design-tool recreation (SearchToDetailTransition.dc.html):
// tapping a poster in a grid/search result should feel like it GROWS into the
// detail hero poster, not just a hard route cut. The design doc hand-rolled a
// getBoundingClientRect + fixed-position "flying poster" FLIP animation — real,
// but a lot of custom rect-measuring machinery to maintain across route changes.
//
// The browser's View Transitions API does the same shared-element morph for
// free: tag the SOURCE poster and the DESTINATION hero poster with the same
// `view-transition-name` right as navigation fires, and the browser captures
// before/after snapshots and cross-fades/morphs between them automatically.
// Undetectable support (Safari/Firefox as of this writing) and reduced-motion
// both fall through to a plain `navigate()`, so this is purely additive.
//
// The name is applied to the CLICKED element only, at click time, and cleared
// once the transition settles — not baked into every poster permanently, since
// many posters of the same show can be on screen at once (a shelf + a search
// result) and view-transition-names must be unique among the elements actually
// transitioning.
export const SHARED_POSTER_VT_NAME = 'nxt-shared-poster'

export function navigateToShow(navigate, showId, e) {
  const path = `/show/${showId}`
  const supported = typeof document !== 'undefined' && typeof document.startViewTransition === 'function'
  const reduce = typeof window !== 'undefined' &&
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  if (!supported || reduce) { navigate(path); return }

  const card = e?.currentTarget
  const img = card?.querySelector?.('img')
  if (!img) { navigate(path); return }

  img.style.viewTransitionName = SHARED_POSTER_VT_NAME
  const cleanup = () => { img.style.viewTransitionName = '' }
  try {
    // Return a promise so the "new" snapshot is captured AFTER React has committed the
    // show page (navigate() only schedules the render). NOT requestAnimationFrame: rendering
    // is suppressed while the update callback runs, so rAF never fires and the transition
    // times out (caught headless, 17.150). A macrotask is after React's commit for a
    // discrete event. A show already in the list renders its hero synchronously from
    // wl.items; a Search result that still has to fetch simply gets the plain cross-fade.
    const transition = document.startViewTransition(() => { navigate(path); return new Promise(r => setTimeout(r, 0)) })
    // startViewTransition() returns THREE independent promises (ready, updateCallbackDone,
    // finished). Only awaiting .finished left .ready's rejection uncaught whenever a second
    // tap fired before the first transition settled — a normal thing for anyone browsing
    // quickly — surfacing as an "unhandledrejection: Transition was aborted because of
    // invalid state" js_error. All three need a swallow, not just the one we care about.
    transition.ready.catch(() => {})
    transition.updateCallbackDone.catch(() => {})
    transition.finished.finally(cleanup).catch(() => {})
  } catch {
    cleanup()
    navigate(path)
  }
}
